export enum ChangesMap {
    draw = 'draw',
    bbox = 'bbox',
    other = 'other',
}
